import { useEffect } from 'react';
const GlobalWidgets = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-LNNBBTRGEJ';
    script.async = true;
    document.head.appendChild(script);

    const initScript = document.createElement('script');
    initScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-LNNBBTRGEJ');
    `;
    document.head.appendChild(initScript);
  }, []);

  return null;
};
export default GlobalWidgets;